<template>
  <span>{{ formattedValue }}</span>
</template>

<script>
export default {
  name: "CurrencyFormatter",
  data() {
    return {};
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    currency: {
      type: String,
      required: true,
      default: "NZD"
    },
  },
  methods: {
    getLocale() {
      if (navigator.languages && navigator.languages.length) {
        return navigator.languages[0];
      } else {
        return "en-NZ"; // what should this be??
      }
    },
  },
  watch: {},
  computed: {
    formattedValue() {
      let locale = this.getLocale();
      if(typeof this.value != "number" || isNaN(this.value)){
        return;
      }
      return new Intl.NumberFormat(locale, { style: "currency", currency: this.currency, currencyDisplay: "narrowSymbol" }).format(this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  padding: 0;
  margin: 0;
}

</style>
